import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMultisyllabicKeyboardApplyRule } from '../../../../mechanics/rid-multisyllabic-keyboard-apply-rule/rid-multisyllabic-keyboard-apply-rule';

@Component({
  selector: 'app-syllabic-keyboard-plus-apply-rule-page',
  imports: [RidMultisyllabicKeyboardApplyRule],
  templateUrl: './syllabic-keyboard-plus-apply-rule-page.html',
})
export class SyllabicKeyboardPlusApplyRulePage {
  protected readonly $router = inject(Router);
}
